'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CogAlternate = require('./CogAlternate');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CogAlternate).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/CogAlternate/index.js
// module id = 1159
// module chunks = 1